// extracted by mini-css-extract-plugin
export var actionButton = "_jf-0";
export var fileInput = "_jf-2";
export var paperclip = "_jf-1";